module.exports = __webpack_public_path__ + "static/media/datacamp_logo.8b5594c0.svg";